import { OtherAttachment } from './model';

export interface DetailsOtherAttachmentsState {
  readonly otherAttachments: OtherAttachment[];
  readonly requestState: OtherAttachmentsUIState;
  readonly urlForDownload: string;
  readonly urlForPreview: string;
}

export enum OtherAttachmentsUIState {
  NotSetYet = 0,
  Downloaded = 100,
  DownloadFail = 101,
  Uploaded = 102,
  UploadFail = 103,
  Deleted = 104,
  DeleteFail = 105,
  Downloading = 200,
  Uploading = 201,
  Deleting = 202,
  HasOfflineOtherAttachmentsForUpload = 300
}

export const enum DetailsOtherAttachmentsActionTypes {
  FETCH_OTHER_ATTACHMENTS = '@@detailsOtherAttachments/FETCH_OTHER_ATTACHMENTS',
  FETCH_OTHER_ATTACHMENTS_FAIL = '@@detailsOtherAttachments/FETCH_OTHER_ATTACHMENTS_FAIL',
  FETCH_OTHER_ATTACHMENTS_SUCCESS = '@@detailsOtherAttachments/FETCH_OTHER_ATTACHMENTS_SUCCESS',
  UPLOAD_OTHER_ATTACHMENTS = '@@detailsImage/UPLOAD_OTHER_ATTACHMENTS',
  UPLOAD_OTHER_ATTACHMENTS_FAIL = '@@detailsOtherAttachments/UPLOAD_OTHER_ATTACHMENTS_FAIL',
  UPLOAD_OTHER_ATTACHMENTS_SUCCESS = '@@detailsOtherAttachments/UPLOAD_OTHER_ATTACHMENTS_SUCCESS',
  DELETE_OTHER_ATTACHMENTS = '@@detailsImage/DELETE_OTHER_ATTACHMENTS',
  DELETE_OTHER_ATTACHMENTS_FAIL = '@@detailsOtherAttachments/DELETE_OTHER_ATTACHMENTS_FAIL',
  DELETE_OTHER_ATTACHMENTS_SUCCESS = '@@detailsOtherAttachments/DELETE_OTHER_ATTACHMENTS_SUCCESS',
  RESET_STATE = '@@detailsOtherAttachments/RESET_STATE',
  SET_OTHER_ATTACHMENTS_REQUEST_STATE = '@@detailsOtherAttachments/SET_OTHER_ATTACHMENTS_REQUEST_STATE',
  ADD_OTHER_ATTACHMENTS = '@@detailsOtherAttachments/ADD_OTHER_ATTACHMENTS',
  UPDATE_DESCRIPTION = '@@detailsOtherAttachments/UPDATE_DESCRIPTION'
}
